/**
 * NOTE: iOS-only
 */
export const useTrackSmartAppBanner = () => {};
